module.exports = "<div class=\"shelfProductTileOffer\" ng-style=\"::$ctrl.containerStyle\" ng-class=\"::$ctrl.classModifier\">\r\n    <p\r\n        class=\"shelfProductTileOffer-text\"\r\n        ng-style=\"::$ctrl.tagStyle\"\r\n        ng-bind-html=\"::$ctrl.$sce.trustAsHtml($ctrl.headerTag.Content)\">\r\n    </p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/shelfproduct/shelf-product-tile-offer.component.html
// module id = 444
// module chunks = 0